// Stepts for homepage
const onboardingSteps = [
{
    element: ".table",
    popover: {
        className: 'first-step-popover-class',
        title: '🙋<br>Začíname',
        description: '<b>Na tejto stránke máš prehľad nad všetkými ľuďmi, kde spravuješ preboarding, onboarding a rozvoj zamestnancov. </b><br><br> Nového zamestnanca pridáš zo záložky "Hiring" (ak sekcii využívaš) a nastavíš mu kolo "K prijatiu". Inak ho možno pridať aj pluskom vpravo hore 👌',
        position: 'bottom-center',
        showButtons: true,
    },

},
{
    element: ".filters-wrapper",
    popover: {
        title: '🥳<br>Vďaka timeline máš prehľad nad celým priebehom onboardingu',
        description: 'Medzi jednotlivými fázami onboardingu si môžeš preklikávať a <b>vidieť zamestnancov, ktorí práve prechádzajú touto fázou.</b> V červenom kruhu <div class="badge badge-timeline-red"><span>3</span></div> vidíš ich celkový počet.',
        position: 'bottom-center',
        showButtons: true,
    },
},
{
    element: ".filters-loop-wrapper",
    popover: {
        title: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>',
        description: '<b>Zamestnanci sa po timeline Onboardingu posúvajú automaticky.</b> Stačí vybrať dátum ich nástupu do zamestnania.<br><br><i>Na rozdiel od sekcie "Hiring", kde si vyberáš, koho a kedy posleš do ďalšieho kola.</i>',
        position: 'bottom-center',
        showButtons: true,
    },


},
{
    element: ".table",
    popover: {
        title: "🧑<br>Prehľad zamestnancov",
        description: 'Ku každému zamestnancovi si môžeš pridávať značky, skúsenosti, ★ hodnotenia a vlastné poznámky.',
        position: 'bottom-center',
        showButtons: true,
    },

},
{
    element: ".filters-bar",
    popover: {
        title: ' ',
        description: '<b>Vo východiskom stave vidíš všetkých zamestnancov bez ohľadu na pracovnú pozíciu. </b> Odporúčame vyskúšať filter podľa pracovnej pozície. Ľahko tak uvidíš, ako prebieha onboarding rôznych skupín zamestnancov. 🙂',
        position: 'bottom',
        showButtons: true,
    },

},
{
    element: ".edit",
    popover: {
        className: 'image-popover',
        title: '<a href="../onboarding?profile=12" target="_blank" title="Více"><img src="/images/guide-onboarding-1.png"></a>',
        description: '<b>Dátum nástupu a zoznam úloh pre HR oddelenie aj zamestnancov </b> môžeš sledovať a editovať kliknutím na ikonu <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-3"><path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path></svg>. ',
        position: 'bottom-right',
        showButtons: true,
    },

},
{
    element: "#sidebar",
    popover: {
        title: 'Paráda!',
        description: 'Pozri si, ako je na tom zoznam tvojich úloh, ktoré sa týkajú onboardingu<br>(1 min)<br>',
        position: 'right-center',
        showButtons: true,
        showButtons: true,         // Do not show control buttons in footer
        doneBtnText: 'Áno, pokračovať ďalej',
        nextBtnText: 'Rozumiem',        // Next button text for this step
        prevBtnText: 'Späť',
    },
    onNext: () => {
        // Prevent moving to the next step
        window.location.assign("/onboarding/checklist#guide");

    }
},
]



export default onboardingSteps
